import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Twitter, Instagram, Mail, Phone, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-black text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/home" className="inline-flex items-center gap-2 text-2xl font-bold text-white hover:text-red-500 transition-colors">
              <img src="/logo.webp" alt="IT Shop Logo" className="h-8 w-8 object-contain rounded-full" /> IT Shop
            </Link>
            <p className="mt-4 text-gray-300 text-sm leading-relaxed">
              ร้านขายสินค้าไอทีคุณภาพ ราคาดี จัดส่งรวดเร็ว พร้อมบริการหลังการขายที่ดีที่สุด
            </p>
            <div className="mt-6 flex space-x-3">
              <button type="button" className="w-10 h-10 rounded-lg bg-gray-800 flex items-center justify-center text-gray-300 hover:bg-red-600 hover:text-white transition-all">
                <Facebook size={18} />
              </button>
              <button type="button" className="w-10 h-10 rounded-lg bg-gray-800 flex items-center justify-center text-gray-300 hover:bg-red-600 hover:text-white transition-all">
                <Twitter size={18} />
              </button>
              <button type="button" className="w-10 h-10 rounded-lg bg-gray-800 flex items-center justify-center text-gray-300 hover:bg-red-600 hover:text-white transition-all">
                <Instagram size={18} />
              </button>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">ลิงก์ด่วน</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/all-products" className="text-gray-300 hover:text-red-500 transition-colors text-sm">
                  สินค้าทั้งหมด
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-red-500 transition-colors text-sm">
                  เกี่ยวกับเรา
                </Link>
              </li>
              <li>
                <Link to="/account/orders" className="text-gray-300 hover:text-red-500 transition-colors text-sm">
                  ติดตามคำสั่งซื้อ
                </Link>
              </li>
              <li>
                <Link to="/account/seller-form" className="text-gray-300 hover:text-red-500 transition-colors text-sm">
                  สมัครเป็นผู้ขาย
                </Link>
              </li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">บริการลูกค้า</h3>
            <ul className="space-y-3">
              <li>
                <button type="button" className="text-gray-300 hover:text-red-500 transition-colors text-sm bg-transparent border-none p-0 cursor-pointer">
                  วิธีการสั่งซื้อ
                </button>
              </li>
              <li>
                <button type="button" className="text-gray-300 hover:text-red-500 transition-colors text-sm bg-transparent border-none p-0 cursor-pointer">
                  การจัดส่งสินค้า
                </button>
              </li>
              <li>
                <button type="button" className="text-gray-300 hover:text-red-500 transition-colors text-sm bg-transparent border-none p-0 cursor-pointer">
                  นโยบายคืนสินค้า
                </button>
              </li>
              <li>
                <button type="button" className="text-gray-300 hover:text-red-500 transition-colors text-sm bg-transparent border-none p-0 cursor-pointer">
                  คำถามที่พบบ่อย
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">ติดต่อเรา</h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-gray-300 text-sm">
                <Phone size={16} className="text-red-500" />
                02-123-4567
              </li>
              <li className="flex items-center gap-3 text-gray-300 text-sm">
                <Mail size={16} className="text-red-500" />
                support@itshop.com
              </li>
              <li className="flex items-start gap-3 text-gray-300 text-sm">
                <MapPin size={16} className="text-red-500 mt-0.5" />
                123 ถนนเทคโนโลยี, กรุงเทพฯ 10110
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © 2024 IT Shop. สงวนลิขสิทธิ์ทั้งหมด
            </p>
            <p className="text-gray-400 text-sm flex items-center gap-1">
              สร้างโดย wintapas
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
